import { render, staticRenderFns } from "./servecontent-add-or-update.vue?vue&type=template&id=127a89e2&"
import script from "./servecontent-add-or-update.vue?vue&type=script&lang=js&"
export * from "./servecontent-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports